var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74090",
    transform: "translate(-1801 -360)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 180",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1801 360)",
    fill: "#0fb709"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1536",
    d: "M1815.362 366.326a.989.989 0 1 1 1.375 1.421l-6.4 6.4a.994.994 0 0 1-1 .25 1.062 1.062 0 0 1-.453-.3q-1.576-1.578-3.154-3.155a.99.99 0 1 1 1.4-1.4l2.507 2.506q2.866-2.857 5.725-5.722Z",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTick);
export default __webpack_public_path__ + "static/media/selectTick.0bb1ccf83505ebc29f4c1afd7cf7b21c.svg";
export { ForwardRef as ReactComponent };